import { render, staticRenderFns } from "./onepicture.vue?vue&type=template&id=30b3bbc0&scoped=true&"
import script from "./onepicture.vue?vue&type=script&setup=true&lang=js&"
export * from "./onepicture.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3bbc0",
  null
  
)

export default component.exports